export default (pathname:string) => {
  const regexEtraSlashes = /\/+/g;
  const regexpTrailingSlashes = /\/+$/;

  return pathname.replace(regexEtraSlashes, '/').replace(regexpTrailingSlashes, '');
};
